<template>
  <div>
    <img :src="getUserLogo" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      logo: "",
      defaults: require("@/assets/images/logo/bip.png"),
      header: false,
      company: require("@/assets/images/portrait/small/avatar-s-271.png"),
    };
  },
  computed: {
    getLogo() {
      return this.$store.getters.companyImg;
    },
    getUserLogo() {
      this.header = this.$store.getters.header;
      if (this.header) {
        if (typeof this.$store.getters.companyImg == "string")
          return this.$store.getters.companyImg;
        else return this.defaults;
      } else return this.defaults;
    },
  },
  watch: {
    getLogo: function (newValue) {
      if (newValue !== undefined) {
        localStorage.setItem("logo", this.$store.getters.companyImg);
      }
      var logo = localStorage.getItem("logo");
      this.logo = newValue !== undefined ? newValue : logo;
      if (this.logo == null || this.logo == "null") {
        if (this.$route.params.slug) {
          this.getCompanyLogoImage();
        } else this.getSettings();
      }
    },

    $route(to, from) {
      if (this.$route.params.slug) {
        this.getCompanyLogoImage(this.$route.params.slug);
      } else this.getSettings();
    },
  },
  created() {
    if (this.$route.params.slug) {
      this.getCompanyLogoImage(this.$route.params.slug);
    } else this.getSettings();
  },
  methods: {
    getSettings() {
      this.$store
        .dispatch("GetSystemSettings")
        .then((res) => {
          this.$vs.loading.close();
          this.logo = res.data.data.logo.path;
          this.header = this.$store.getters.header;
        })
        .catch((error) => {
          this.$log.error(
            "File : getSetting.vue | Function : getSettings() | Error :",
            error
          );
          return false;
        });
    },

    getCompanyLogoImage(slug) {
      this.$store.dispatch("CompanyDetails", slug).then((res) => {
        this.logo = res.data.data.profile_image
          ? res.data.data.profile_image
          : require("@/assets/images/portrait/small/avatar-s-271.png");
        this.header = res.data.data.enable_header_footer;
        this.$store.commit("COMPANY_IMG", res.data.data.profile_image);
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
img {
 width: 5rem !important;
  height: 5rem !important;
  border-radius: 50% !important;
}
</style>
